import { BellRing } from "lucide-react";
import { Switch } from "./ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const ISO_RANGES = (fr) => [
  ["25", "25 km"], ["50", "50 km"], ["100", "100 km"], ["250", "250 km"],
  ["province", fr ? "Ma province" : "My province"], ["canada", fr ? "Tout le Canada" : "All of Canada"],
];

// Switch + range picker for ISO match alerts (used in Post Ad and on the owner's ISO ad)
export const IsoAlertFields = ({ on, range, onChange, fr, disabled }) => (
  <div className="rounded-xl border border-[#FFC233]/70 bg-[#FFF9E8] p-4 space-y-3" data-testid="iso-alert-fields">
    <div className="flex items-start gap-3">
      <BellRing size={18} className="text-[#F5551E] mt-0.5 shrink-0" />
      <div className="flex-1">
        <p className="font-semibold text-[#12234A] text-sm">{fr ? "M'avertir des annonces correspondantes" : "Email me matching ads"}</p>
        <p className="text-xs text-slate-500 mt-0.5">{fr ? "Dès qu'une annonce de cette race (ou espèce) est publiée dans votre zone." : "As soon as an ad for this breed (or species, if no breed) is posted in your range."}</p>
      </div>
      <Switch checked={on} disabled={disabled} onCheckedChange={(v) => onChange({ iso_alert: v, iso_range: range })} data-testid="iso-alert-toggle" />
    </div>
    {on && (
      <div className="flex items-center gap-2 text-sm text-[#12234A] pl-7">
        <span className="shrink-0">{fr ? "Zone :" : "Range:"}</span>
        <Select value={range} disabled={disabled} onValueChange={(v) => onChange({ iso_alert: on, iso_range: v })}>
          <SelectTrigger className="h-9 w-48 rounded-lg bg-white" data-testid="iso-range-select"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">{ISO_RANGES(fr).map(([v, l]) => <SelectItem key={v} value={v}>{["25", "50", "100", "250"].includes(v) ? (fr ? `Dans un rayon de ${l}` : `Within ${l}`) : l}</SelectItem>)}</SelectContent>
        </Select>
      </div>
    )}
  </div>
);
